"use client";

import React, { useState, useEffect, useRef } from "react";
import img_user from "../../../../../public/assets/images/icons/user.png"
import Image from "next/image";
import Link from "next/link";
import Cookies from 'cookies-js';
import axiosConfig from "@/src/utils/axiosConfig.ts";

interface NavBarProps {
    user: object,
    params: { lang: string };
    setChange: any;
}

const NavBar = ({ user, params, setChange }: NavBarProps) => {
    const [menuActive, setMenuActive] = useState(false);
    const navRef = useRef<HTMLDivElement>(null); 
    const isArabic = params?.lang === "ar";


    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    // SECURITY FIX: Proper session invalidation (CWE-384)
    const removeCookies = async () => {
        try {
            // Call backend logout endpoint to invalidate session server-side
            const token = Cookies.get('authToken');
            if (token) {
                await axiosConfig.post('/api/Auth/Logout', {}, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Cache-Control': 'no-cache, no-store, must-revalidate'
                    }
                }).catch(err => {
                    console.error('Logout API call failed:', err);
                    // Continue with client-side cleanup even if API fails
                });
            }
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            // Always clear client-side data regardless of API response
            Cookies.expire('authToken');
            // Clear any other stored data
            if (typeof window !== 'undefined') {
                localStorage.removeItem('authToken');
                localStorage.removeItem('user');
                sessionStorage.clear();
            }
            setChange((prev: any) => !prev); 
            setMenuActive(!menuActive);
        }
    };

    // on click in out component close it 
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (navRef.current && !navRef.current.contains(event.target as Node)) {
                setMenuActive(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            {/* Profile Section */}
            <div
                className="flex items-center gap-3 cursor-pointer relative"
                onClick={toggleMenu}
            >
                <div className="text-right">
                    <h3 className="text-sm font-semibold dark:text-white">{user?.Emial?.split("@")[0]}</h3>
                    <p className="text-xs opacity-60 dark:text-gray-300">{user?.Roles}</p>
                </div>
                <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image
                        src={img_user}
                        alt="User"
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>

            {/* Dropdown Menu */}
            <div
            ref={navRef}
                className={`absolute top-[calc(100%+20px)] rounded-md ${isArabic ? "left-4" : "right-4"
                    } w-48 bg-white shadow-lg transform transition-all duration-300 ${menuActive ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-2 invisible"
                    }`}
            >
                <div
                    className={`absolute -top-2 ${isArabic ? "left-3" : "right-3"
                        } w-5 h-5 bg-white transform rotate-45`}
                ></div>
                <ul className="flex flex-col overflow-hidden rounded-md ">
                    <li className="hover:bg-gray-100">
                        <Link
                            href={isArabic ? "/ar/user" : "/en/user"}
                            onClick={()=> setMenuActive(!menuActive)}
                            className="flex items-center gap-2 p-3 text-black text-sm"
                        >
                            <i className="ph-bold ph-user"></i> {isArabic ? "الملف الشخصي" : "Profile"}
                        </Link>
                    </li>
                    <li className="hover:bg-gray-100">
                        <Link
                            href={isArabic ? "/ar/contact" : "/en/contact"}
                            className="flex items-center gap-2 p-3 text-black text-sm"
                            onClick={()=> setMenuActive(!menuActive)}
                        >
                            <i className="ph-bold ph-question"></i>{" "}
                            {isArabic ? "المساعدة" : "Help"}
                        </Link>
                    </li>
                    <li className="hover:bg-gray-100">
                        <button
                            onClick={removeCookies}
                            className="flex items-center gap-2 p-3 text-[#e74c3c] text-sm"
                        >
                            <i className=" ph-bold ph-sign-out"></i>{" "}
                            {isArabic ? "تسجيل الخروج" : "Sign Out"}
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default NavBar;
